import React from 'react'
import Aside from '../../Components/aside'
import TopBar from '../../Components/topBar'

const JudgementtablePage = () => {
  return (
    <div className="main-wrapper">

      <div className="content-wrapper">
       <div>JudgementTable</div>
      </div>
    </div>
  )
}

export default JudgementtablePage